import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { BASE_URL } from '../../config/env';

export const notificationApi = createApi({
  reducerPath: 'notificationApi',
  tagTypes: ['ManualNotifications'],
  baseQuery: fetchBaseQuery({
    baseUrl: BASE_URL,
    prepareHeaders: (headers, { getState }) => {
      const token = getState()?.auth?.token;
      if (token) {
        headers.set('authorization', `Bearer ${token}`);
      }
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getManualNotifications: builder.query({
      query: () => 'notifications/manual',
      providesTags: ['ManualNotifications'],
    }),

    getAutoNotifications: builder.query({
      query: () => 'notifications/auto',
    }),

    sendNotification: builder.mutation({
      query: (body) => ({
        url: 'notifications/send',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['ManualNotifications'],
    }),

    scheduleNotification: builder.mutation({
      query: (body) => ({
        url: 'notifications/schedule',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['ManualNotifications'],
    }),

    updateScheduledNotification: builder.mutation({
      query: ({ id, ...body }) => ({
        url: `notifications/schedule/${id}`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: ['ManualNotifications'],
    }),

    getNotificationDetails: builder.query({
      query: (id) => `notifications/${id}/details`,
    }),
  }),
});

export const {
  useGetManualNotificationsQuery,
  useGetAutoNotificationsQuery,
  useSendNotificationMutation,
  useScheduleNotificationMutation,
  useUpdateScheduledNotificationMutation,
  useGetNotificationDetailsQuery,
} = notificationApi;
